require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/~/core-js/library/modules/es7.symbol.observable.js
// module id = C8Mb
// module chunks = 0